const COLLAPSED_MODULE_SECTIONS_STORAGE_KEY = "collapsedModuleSections";

interface PersistantCollapsedModuleSectionInterface {
  isCollapsedModuleSection: (sectionId: number) => boolean;
  addToCollapsedModuleSections: (sectionId: number) => void;
  removeFromCollapsedModuleSections: (sectionId: number) => void;
}

export default (): PersistantCollapsedModuleSectionInterface => {
  const getCollapsedModuleSectionIds = () => {
    const storedCollapsedModuleSectionIds = localStorage.getItem(
      COLLAPSED_MODULE_SECTIONS_STORAGE_KEY,
    );
    if (storedCollapsedModuleSectionIds) {
      return storedCollapsedModuleSectionIds.split(",");
    }

    return [];
  };

  // Check if a specific section is already marked as collapsed in the local storage
  const isCollapsedModuleSection = (sectionId: number): boolean => {
    const collapsedModuleSectionIds = getCollapsedModuleSectionIds();
    return collapsedModuleSectionIds.includes(sectionId.toString());
  };

  // Add a new section to the list of collapsed sections in the local storage
  const addToCollapsedModuleSections = (sectionId: number) => {
    const prevCollapsedModuleSectionIds = getCollapsedModuleSectionIds();
    const updatedCollapsedModuleSectionIds = [...prevCollapsedModuleSectionIds, sectionId];
    localStorage.setItem(
      COLLAPSED_MODULE_SECTIONS_STORAGE_KEY,
      updatedCollapsedModuleSectionIds.join(","),
    );
  };

  // Remove a section from the list of collapsed sections in the local storage
  const removeFromCollapsedModuleSections = (sectionId: number) => {
    const prevCollapsedModuleSectionIds = getCollapsedModuleSectionIds();
    const updatedCollapsedModuleSectionIds = prevCollapsedModuleSectionIds.filter(
      (collapsedSectionId) => sectionId !== +collapsedSectionId,
    );
    localStorage.setItem(
      COLLAPSED_MODULE_SECTIONS_STORAGE_KEY,
      updatedCollapsedModuleSectionIds.join(","),
    );
  };

  return {
    isCollapsedModuleSection,
    addToCollapsedModuleSections,
    removeFromCollapsedModuleSections,
  };
};
